import util from '@/libs/util';

export default {
  methods: {
    handleMenuSelect (index: any, indexPath: any, onComplete?: () => void) {
      if (/^d2-menu-empty-\d+$/.test(index) || index === undefined) {
        // @ts-ignore
        this.$message.warning('临时菜单')
      } else if (/^https:\/\/|http:\/\//.test(index)) {
        return util.open(index)
      } else {
        console.log('push', index)
        // @ts-ignore
        return this.$router.push(
          { path: index },
          onComplete,
          onComplete
        )
      }
    }
  }
}
